import React from 'react'

const SrServiceTagArea = () => {
  return (
    <section className="service pt-130 pb-110">
    <div className="container">
        <div className="row">
            <div className="col-lg-10">
                <div className="section-title pb-60">
                    <h3 className="title wow fadeInUp" data-wow-duration=".7s">We offer comprehensive services that help businesses establish a <span>strong online presence.</span></h3>
                </div>
            </div>
        </div>
        <div className="service-tag text-center">
            <span>WEBFLOW DEVELOPMENT</span> <br/>
            <span>BRANDING</span>
            <span>WEB DESIGN</span>
            <span>VIDEOGRAPHY</span>
            <span>COPYWRITING</span>
            <span>M0T10N GRAPHICS</span>
            <span>GRAPHIC DESIGN</span>
            <span>VIDEO EDITING</span>
        </div>
    </div>
</section>

  )
}

export default SrServiceTagArea
